export function setBgSrc() {
  var $ = window.jQuery;

  let typedArray = [];
  const defaults = { typeSpeed: 100, loop: true, showCursor: false };

  $(function () {
    $(".background-image-holder").each(function () {
      var b = $(this).children("img").attr("src");
      $(this)
        .css("background", 'url("' + $(this).find("img").attr("src") + '")')
        .css("background-position", "initial")
        .css("opacity", "1");
    });
    // const makeTypedObject = (
    //   element,
    //   strings,
    //   playing = false,
    //   { typeSpeed, loop, showCursor } = defaults
    // ) => {
    //   return $(window).typed(
    //     $.extend(element, { strings, typeSpeed, loop, showCursor })
    //   );
    //   //   return new Typed(element, { strings, typeSpeed, loop, showCursor });
    // };

    // $(".typed-text").each(function (i, el) {
    //   let stringsArray = $(el).attr("data-typed-strings").split(",");

    //   typedArray.push(makeTypedObject(el, stringsArray));

    //   let t = typedArray[i];
    //   t["instance"]["el"].start();
    // });
  });
}
